// 主題切換：深色／淺色／跟隨系統。選擇記在瀏覽器。
import { t } from '../i18n/zh-TW.ts';
import { ICON, type LucideIcon, Monitor, Moon, Sun } from './icons/index.ts';
import type { ThemePref } from './theme/theme.ts';

const OPTIONS: { key: ThemePref; Icon: LucideIcon }[] = [
  { key: 'dark', Icon: Moon },
  { key: 'light', Icon: Sun },
  { key: 'system', Icon: Monitor },
];

/** 狀態由上層的 useTheme 提供（同一頁只有一份主題狀態） */
export function ThemeSwitcher({ pref, onChange }: { pref: ThemePref; onChange: (pref: ThemePref) => void }) {
  return (
    <fieldset className="segmented segmented-icons theme-switcher">
      <legend className="sr-only">{t.theme.label}</legend>
      {OPTIONS.map(({ key, Icon }) => (
        <button
          key={key}
          type="button"
          className={pref === key ? 'seg seg-on' : 'seg'}
          aria-pressed={pref === key}
          aria-label={t.theme.options[key]}
          title={t.theme.options[key]}
          onClick={() => onChange(key)}
        >
          <Icon {...ICON} />
        </button>
      ))}
    </fieldset>
  );
}
